const apiCallOptions = [
  {
    URL: '/tools/payment/avs',
    data: {
      locId: 691,
      paymentTypeId: 432,
      cardReaderType: 'pax',
      paxData: {
        emvData: '',
        trackData: '************6950',
        arqc: '004FFFF98765403FC000AD72607AB776163336F11BC138990BE9D8556ECA301F85BF9FADFD97C9388E60205838ECB1F3D083517',
        ksn: 'FFFF98765403FC000AD7',
        encryptedTrack2Data: '2607AB776163336F11BC138990BE9D8556ECA301F85BF9FADFD97C9388E60205838ECB1F3D083517',
        cardHolderName: 'LENART/ANDREW W',
        cardEntryType: 'Swiped Track 2',
        epxCardEntryType: 'D',
        cardExpiryDate: '09/30/27',
        cardEffectiveDate: '',
        cardBrand: '',
        cardLast4Pan: '6950',
        terminalId: '',
        ifdSerialNumber: '',
        transactionStatus: {
          id: 255,
          description: 'Unknown'
        },
        additionalTransactionInfo: '',
        currencyCode: '',
        decodeStatus: false
      }
    }
  },
  {
    URL: '/tools/payment/batch/close',
    data: {
      batchNumber: 2309220000,
      locId: 691,
      paymentTypeId: 432,
    }
  },
  {
    URL: '/tools/payment/bric/adjustsale',
    data: {
      bric: '00DK509RARR79WWX7AF',
      locId: 691,
      paymentTypeId: 432,
      total: 20.00,
      tip: 4.00,
    }
  },
  {
    URL: '/tools/payment/bric/capture',
    data: {
      bric: '00DK506RKL4WVN6Y6T5',
      locId: 691,
      paymentTypeId: 432,
      total: 10.00,
      tip: 0.00
    }
  },
  {
    URL: '/tools/payment/bric/incpreauth',
    data: {
      bric: '00DK4VT970JEP3JB6LL',
      locId: 691,
      paymentTypeId: 432,
      totalIncrement: 5.00,
      tipIncrement: 0.00
    },
  },
  {
    URL: '/tools/payment/bric/preauth',
    data: {
      bric: '00DK4LPG8PGH5ZNLVF9',
      locId: 691,
      paymentTypeId: 432,
      total: 10.00,
      tip: 0.00
    }
  },
  {
    URL: '/tools/payment/bric/refund',
    data: {
      bric: '00DK50AHMP96K8X670X',
      locId: 691,
      paymentTypeId: 432,
      total: 10.00
    }
  },
  {
    URL: '/tools/payment/bric/sale',
    data: {
      bric: '00DK5059KBEAJEAR6RY',
      locId: 691,
      paymentTypeId: 432,
      total: 10.00,
      tip: 0.00
    }
  },
  {
    URL: '/tools/payment/bric/void',
    data: {
      bric: '00DK509RARR79WWX7AF',
      locId: 691,
      paymentTypeId: 432
    }
  },
  {
    URL: '/tools/payment/preauth',
    data: {
      locId: 691,
      paymentTypeId: 432,
      total: 10.00,
      tip: 0.00,
      cardReaderType: 'pax',
      paxData: {
        emvData: '',
        trackData: '************6950',
        arqc: '004FFFF98765403FC000AD72607AB776163336F11BC138990BE9D8556ECA301F85BF9FADFD97C9388E60205838ECB1F3D083517',
        ksn: 'FFFF98765403FC000AD7',
        encryptedTrack2Data: '2607AB776163336F11BC138990BE9D8556ECA301F85BF9FADFD97C9388E60205838ECB1F3D083517',
        cardHolderName: 'LENART/ANDREW W',
        cardEntryType: 'Swiped Track 2',
        epxCardEntryType: 'D',
        cardExpiryDate: '09/30/27',
        cardEffectiveDate: '',
        cardBrand: '',
        cardLast4Pan: '6950',
        terminalId: '',
        ifdSerialNumber: '',
        transactionStatus: {
          id: 255,
          description: 'Unknown'
        },
        additionalTransactionInfo: '',
        currencyCode: '',
        decodeStatus: false
      }
    }
  },
  {
    URL: '/tools/payment/refund',
    data: {
      locId: 691,
      paymentTypeId: 432,
      total: 10.00,
      tip: 0.00,
      cardReaderType: 'pax',
      paxData: {
        emvData: '',
        trackData: '************6950',
        arqc: '004FFFF98765403FC000AD72607AB776163336F11BC138990BE9D8556ECA301F85BF9FADFD97C9388E60205838ECB1F3D083517',
        ksn: 'FFFF98765403FC000AD7',
        encryptedTrack2Data: '2607AB776163336F11BC138990BE9D8556ECA301F85BF9FADFD97C9388E60205838ECB1F3D083517',
        cardHolderName: 'LENART/ANDREW W',
        cardEntryType: 'Swiped Track 2',
        epxCardEntryType: 'D',
        cardExpiryDate: '09/30/27',
        cardEffectiveDate: '',
        cardBrand: '',
        cardLast4Pan: '6950',
        terminalId: '',
        ifdSerialNumber: '',
        transactionStatus: {
          id: 255,
          description: 'Unknown'
        },
        additionalTransactionInfo: '',
        currencyCode: '',
        decodeStatus: false
      }
    }
  },
  {
    URL: '/tools/payment/sale',
    data: {
      locId: 691,
      paymentTypeId: 432,
      total: 10.00,
      tip: 0.00,
      cardReaderType: 'pax',
      paxData: {
        emvData: '',
        trackData: '************6950',
        arqc: '004FFFF98765403FC000AD72607AB776163336F11BC138990BE9D8556ECA301F85BF9FADFD97C9388E60205838ECB1F3D083517',
        ksn: 'FFFF98765403FC000AD7',
        encryptedTrack2Data: '2607AB776163336F11BC138990BE9D8556ECA301F85BF9FADFD97C9388E60205838ECB1F3D083517',
        cardHolderName: 'LENART/ANDREW W',
        cardEntryType: 'Swiped Track 2',
        epxCardEntryType: 'D',
        cardExpiryDate: '09/30/27',
        cardEffectiveDate: '',
        cardBrand: '',
        cardLast4Pan: '6950',
        terminalId: '',
        ifdSerialNumber: '',
        transactionStatus: {
          id: 255,
          description: 'Unknown'
        },
        additionalTransactionInfo: '',
        currencyCode: '',
        decodeStatus: false
      }
    }
  },
  {
    URL: '/tools/payment/store',
    data: {
      locId: 691,
      paymentTypeId: 432,
      cardReaderType: 'pax',
      paxData: {
        emvData: '',
        trackData: '************6950',
        arqc: '004FFFF98765403FC000AD72607AB776163336F11BC138990BE9D8556ECA301F85BF9FADFD97C9388E60205838ECB1F3D083517',
        ksn: 'FFFF98765403FC000AD7',
        encryptedTrack2Data: '2607AB776163336F11BC138990BE9D8556ECA301F85BF9FADFD97C9388E60205838ECB1F3D083517',
        cardHolderName: 'LENART/ANDREW W',
        cardEntryType: 'Swiped Track 2',
        epxCardEntryType: 'D',
        cardExpiryDate: '09/30/27',
        cardEffectiveDate: '',
        cardBrand: '',
        cardLast4Pan: '6950',
        terminalId: '',
        ifdSerialNumber: '',
        transactionStatus: {
          id: 255,
          description: 'Unknown'
        },
        additionalTransactionInfo: '',
        currencyCode: '',
        decodeStatus: false
      }
    }
  },
];

export { apiCallOptions };
